import React, { useState } from 'react';
import { Tooltip, Button, List, Pagination } from 'antd';
import { FileSearchOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useSwr from '@hooks/useSwr';
import CustomModalInfo from '@components/CustomModalInfo';
import HistoricCard from './HistoricCard';

import * as S from './styles';

const PAGE_SIZE = 5;

export interface HistoricProps {
  alert60: boolean;
  alert70: boolean;
  alert80: boolean;
  alert90: boolean;
  alert100: boolean;
  notificationEmails: string[];
  operation: 'CREATED' | 'UPDATED';
  createdAt: string;
  createdBy: string;
}

const HistoricModal = () => {
  const { t } = useTranslation('alerts');
  const [visible, setVisible] = useState(false);

  const [current, setCurrent] = useState(1);

  const { data } = useSwr<{ content: HistoricProps[]; totalElements: number }>(
    visible ? '/service-proxy/basic-alerts-configuration/history' : null,
    {
      params: {
        page: current - 1,
        linesPerPage: PAGE_SIZE,
      },
    },
  );

  return (
    <>
      <Tooltip placement="top" title={t('consumption.historic')}>
        <Button
          icon={<FileSearchOutlined />}
          onClick={() => setVisible(true)}
        />
      </Tooltip>

      <CustomModalInfo
        title={t('consumption.historic')}
        open={visible}
        onClose={() => setVisible(false)}
      >
        {data ? (
          <S.HistoricContainer>
            <>
              <List
                bordered
                dataSource={data?.content}
                renderItem={item => (
                  <List.Item>
                    <HistoricCard data={item} />
                  </List.Item>
                )}
              />
              <Pagination
                size="small"
                current={current}
                pageSize={PAGE_SIZE}
                total={data?.totalElements}
                onChange={page => setCurrent(page)}
                style={{ textAlign: 'center', marginTop: 16 }}
              />
            </>
          </S.HistoricContainer>
        ) : (
          <div style={{ display: 'grid', padding: 40 }}>
            <LoadingOutlined
              style={{ fontSize: '2rem', color: 'var(--primary-color)' }}
            />
          </div>
        )}
      </CustomModalInfo>
    </>
  );
};

export default HistoricModal;
